import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("verifying");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setMsg("Missing verification token."); return; }
    api.post("/auth/verify-email", { token })
      .then((r) => { setState("ok"); setMsg(r.data.message); })
      .catch((e) => { setState("error"); setMsg(formatApiErrorDetail(e.response?.data?.detail) || "Verification failed."); });
  }, [params]);

  return (
    <AuthShell title="Email verification" subtitle="Confirming your account.">
      <div className="border border-[var(--line)] bg-white p-8 text-center" data-testid="verify-email-result">
        {state === "verifying" && <div className="py-4">Verifying…</div>}
        {state === "ok" && <><CheckCircle2 className="mx-auto text-[var(--accent)] mb-3" size={44} /><p className="mb-6">{msg}</p><Link to="/login" data-testid="verify-to-login" className="inline-block bg-[var(--accent)] text-white font-semibold px-6 py-3 hover:bg-[var(--accent-hover)]">Log in now</Link></>}
        {state === "error" && <><XCircle className="mx-auto text-[var(--destructive,#D50000)] mb-3" size={44} /><p className="mb-6 text-sm text-[var(--ink-2)]">{msg}</p><Link to="/login" className="text-[var(--accent)] font-semibold">Back to login</Link></>}
      </div>
    </AuthShell>
  );
}
